import serviceRest from "./serviceRest";

const sessionFrontendUser = () => {
    return serviceRest.get('/react/user/sessionFrontend');
};

const SessionFrontendService = {
    sessionFrontendUser
};

export default SessionFrontendService;
